//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import domains from '$utils/assets-link'

export default {
  props: {
    isTransparent: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      domains
    }
  },
  created() {
    // console.log(process.env, 34234)
  },
  methods: {
    goHome() {
      this.$ssvue.collectSendRequest('投资首页-logo', 'click')
      setTimeout(() => {
        // location.href = 'https://sui.com'
        this.$router.push('/investment')
      }, 200)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/navHeader/index.vue